// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponseAvailableNotificationsResponse,
  GenericApiResponseListMandate,
  GenericApiResponseListUser,
  GenericApiResponseListUserActivity,
  GenericApiResponsePeopleProfile,
  GenericApiResponsePeopleProfilePhotoUrlResponse,
  GenericApiResponseStudentEngagementRosterInfo,
  GenericApiResponseUser,
  GetAllUsersParams,
  HTTPValidationError,
  PeopleProfilePatchRequest,
  PeopleProfilePhotoUploadRequest,
  UserActivity,
  UserCreate,
  UserUpdate,
} from '../../models';

/**
 * getAll users
 * @summary Get All Users
 */
export const getAllUsers = (
  params?: GetAllUsersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListUser>> => {
  return axios.get(`/users`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetAllUsersQueryKey = (params?: GetAllUsersParams) => {
  return [`/users`, ...(params ? [params] : [])] as const;
};

export const getGetAllUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllUsers>>> = ({ signal }) =>
    getAllUsers(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllUsers>>>;
export type GetAllUsersQueryError = AxiosError<void | HTTPValidationError>;

export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: undefined | GetAllUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get All Users
 */

export function useGetAllUsers<
  TData = Awaited<ReturnType<typeof getAllUsers>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllUsers>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create new user
 * @summary Create User
 */
export const createUser = (userCreate: UserCreate, options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/users`, userCreate, options);
};

export const getCreateUserMutationOptions = <
  TData = Awaited<ReturnType<typeof createUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: UserCreate }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createUser'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, { data: UserCreate }> = (props) => {
    const { data } = props ?? {};

    return createUser(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { data: UserCreate }, TContext>;
};

export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>;
export type CreateUserMutationBody = UserCreate;
export type CreateUserMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Create User
 */
export const useCreateUser = <
  TData = Awaited<ReturnType<typeof createUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: UserCreate }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: UserCreate }, TContext> => {
  const mutationOptions = getCreateUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get user and their activity context
 * @summary Get User
 */
export const getUser = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseUser>> => {
  return axios.get(`/users/${userId}`, options);
};

export const getGetUserQueryKey = (userId: string) => {
  return [`/users/${userId}`] as const;
};

export const getGetUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) =>
    getUser(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>;
export type GetUserQueryError = AxiosError<void | HTTPValidationError>;

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User
 */

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * update existing user with all passed fields
 * @summary Update User
 */
export const updateUser = (
  userId: string,
  userUpdate: UserUpdate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.put(`/users/${userId}`, userUpdate, options);
};

export const getUpdateUserMutationOptions = <
  TData = Awaited<ReturnType<typeof updateUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: UserUpdate }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateUser'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, { userId: string; data: UserUpdate }> = (
    props,
  ) => {
    const { userId, data } = props ?? {};

    return updateUser(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; data: UserUpdate },
    TContext
  >;
};

export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>;
export type UpdateUserMutationBody = UserUpdate;
export type UpdateUserMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Update User
 */
export const useUpdateUser = <
  TData = Awaited<ReturnType<typeof updateUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: UserUpdate }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; data: UserUpdate }, TContext> => {
  const mutationOptions = getUpdateUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * update existing user, only passed fields are updated
 * @summary Patch User
 */
export const patchUser = (
  userId: string,
  userUpdate: UserUpdate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.patch(`/users/${userId}`, userUpdate, options);
};

export const getPatchUserMutationOptions = <
  TData = Awaited<ReturnType<typeof patchUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: UserUpdate }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['patchUser'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUser>>, { userId: string; data: UserUpdate }> = (
    props,
  ) => {
    const { userId, data } = props ?? {};

    return patchUser(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; data: UserUpdate },
    TContext
  >;
};

export type PatchUserMutationResult = NonNullable<Awaited<ReturnType<typeof patchUser>>>;
export type PatchUserMutationBody = UserUpdate;
export type PatchUserMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Patch User
 */
export const usePatchUser = <
  TData = Awaited<ReturnType<typeof patchUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: UserUpdate }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; data: UserUpdate }, TContext> => {
  const mutationOptions = getPatchUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * delete user
 * @summary Delete User
 */
export const deleteUser = (userId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
  return axios.delete(`/users/${userId}`, options);
};

export const getDeleteUserMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteUser'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, { userId: string }> = (props) => {
    const { userId } = props ?? {};

    return deleteUser(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { userId: string }, TContext>;
};

export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>;

export type DeleteUserMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Delete User
 */
export const useDeleteUser = <
  TData = Awaited<ReturnType<typeof deleteUser>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string }, TContext> => {
  const mutationOptions = getDeleteUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Trigger a password reset email for a user (admin only).
 * @summary Trigger Password Reset
 */
export const triggerPasswordReset = (userId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/users/${userId}/trigger-password-reset`, undefined, options);
};

export const getTriggerPasswordResetMutationOptions = <
  TData = Awaited<ReturnType<typeof triggerPasswordReset>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['triggerPasswordReset'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerPasswordReset>>, { userId: string }> = (
    props,
  ) => {
    const { userId } = props ?? {};

    return triggerPasswordReset(userId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { userId: string }, TContext>;
};

export type TriggerPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof triggerPasswordReset>>>;

export type TriggerPasswordResetMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Trigger Password Reset
 */
export const useTriggerPasswordReset = <
  TData = Awaited<ReturnType<typeof triggerPasswordReset>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string }, TContext> => {
  const mutationOptions = getTriggerPasswordResetMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Return the catalog of available (configurable) notification kinds for the user.

Excludes whitelisted/mandatory kinds; does not include effective state.
 * @summary Get Available Notification Kinds
 */
export const getAvailableNotificationKinds = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseAvailableNotificationsResponse>> => {
  return axios.get(`/users/${userId}/notification-preferences/available`, options);
};

export const getGetAvailableNotificationKindsQueryKey = (userId: string) => {
  return [`/users/${userId}/notification-preferences/available`] as const;
};

export const getGetAvailableNotificationKindsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableNotificationKinds>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableNotificationKinds>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableNotificationKindsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableNotificationKinds>>> = ({ signal }) =>
    getAvailableNotificationKinds(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableNotificationKinds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailableNotificationKindsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableNotificationKinds>>
>;
export type GetAvailableNotificationKindsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetAvailableNotificationKinds<
  TData = Awaited<ReturnType<typeof getAvailableNotificationKinds>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableNotificationKinds>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getAvailableNotificationKinds>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableNotificationKinds<
  TData = Awaited<ReturnType<typeof getAvailableNotificationKinds>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableNotificationKinds>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAvailableNotificationKinds>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAvailableNotificationKinds<
  TData = Awaited<ReturnType<typeof getAvailableNotificationKinds>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableNotificationKinds>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Available Notification Kinds
 */

export function useGetAvailableNotificationKinds<
  TData = Awaited<ReturnType<typeof getAvailableNotificationKinds>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableNotificationKinds>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAvailableNotificationKindsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * log user activity
 * @summary Log User Activity
 */
export const logUserActivity = (
  userId: string,
  userActivity: UserActivity,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.post(`/users/${userId}/activity`, userActivity, options);
};

export const getLogUserActivityMutationOptions = <
  TData = Awaited<ReturnType<typeof logUserActivity>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: UserActivity }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['logUserActivity'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logUserActivity>>,
    { userId: string; data: UserActivity }
  > = (props) => {
    const { userId, data } = props ?? {};

    return logUserActivity(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; data: UserActivity },
    TContext
  >;
};

export type LogUserActivityMutationResult = NonNullable<Awaited<ReturnType<typeof logUserActivity>>>;
export type LogUserActivityMutationBody = UserActivity;
export type LogUserActivityMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Log User Activity
 */
export const useLogUserActivity = <
  TData = Awaited<ReturnType<typeof logUserActivity>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: UserActivity }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; data: UserActivity }, TContext> => {
  const mutationOptions = getLogUserActivityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * get user activity
 * @summary Get User Activity
 */
export const getUserActivity = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListUserActivity>> => {
  return axios.get(`/users/${userId}/activity`, options);
};

export const getGetUserActivityQueryKey = (userId: string) => {
  return [`/users/${userId}/activity`] as const;
};

export const getGetUserActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserActivity>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserActivity>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserActivityQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserActivity>>> = ({ signal }) =>
    getUserActivity(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getUserActivity>>>;
export type GetUserActivityQueryError = AxiosError<void | HTTPValidationError>;

export function useGetUserActivity<
  TData = Awaited<ReturnType<typeof getUserActivity>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserActivity>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getUserActivity>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserActivity<
  TData = Awaited<ReturnType<typeof getUserActivity>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserActivity>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getUserActivity>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserActivity<
  TData = Awaited<ReturnType<typeof getUserActivity>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserActivity>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Activity
 */

export function useGetUserActivity<
  TData = Awaited<ReturnType<typeof getUserActivity>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserActivity>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserActivityQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all active mandates (Evaluator or Facilitator) for the user.
 * @summary Get User Mandates
 */
export const getUserMandates = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListMandate>> => {
  return axios.get(`/users/${userId}/mandates`, options);
};

export const getGetUserMandatesQueryKey = (userId: string) => {
  return [`/users/${userId}/mandates`] as const;
};

export const getGetUserMandatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserMandates>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMandates>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserMandatesQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserMandates>>> = ({ signal }) =>
    getUserMandates(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserMandates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserMandatesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserMandates>>>;
export type GetUserMandatesQueryError = AxiosError<void | HTTPValidationError>;

export function useGetUserMandates<
  TData = Awaited<ReturnType<typeof getUserMandates>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMandates>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getUserMandates>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserMandates<
  TData = Awaited<ReturnType<typeof getUserMandates>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMandates>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getUserMandates>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserMandates<
  TData = Awaited<ReturnType<typeof getUserMandates>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMandates>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Mandates
 */

export function useGetUserMandates<
  TData = Awaited<ReturnType<typeof getUserMandates>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMandates>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserMandatesQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all students currently in the lecturer's mandates pipeline.
 * @summary Get My Students
 */
export const getMyStudents = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseStudentEngagementRosterInfo>> => {
  return axios.get(`/users/${userId}/my-students`, options);
};

export const getGetMyStudentsQueryKey = (userId: string) => {
  return [`/users/${userId}/my-students`] as const;
};

export const getGetMyStudentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyStudents>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStudents>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyStudentsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStudents>>> = ({ signal }) =>
    getMyStudents(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyStudents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyStudentsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStudents>>>;
export type GetMyStudentsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetMyStudents<
  TData = Awaited<ReturnType<typeof getMyStudents>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStudents>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getMyStudents>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyStudents<
  TData = Awaited<ReturnType<typeof getMyStudents>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStudents>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getMyStudents>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyStudents<
  TData = Awaited<ReturnType<typeof getMyStudents>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStudents>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get My Students
 */

export function useGetMyStudents<
  TData = Awaited<ReturnType<typeof getMyStudents>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStudents>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyStudentsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return shareable contact settings for the owner.
 * @summary Get People Profile
 */
export const getPeopleProfile = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponsePeopleProfile>> => {
  return axios.get(`/users/${userId}/people-profile`, options);
};

export const getGetPeopleProfileQueryKey = (userId: string) => {
  return [`/users/${userId}/people-profile`] as const;
};

export const getGetPeopleProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getPeopleProfile>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfile>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPeopleProfileQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeopleProfile>>> = ({ signal }) =>
    getPeopleProfile(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPeopleProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPeopleProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getPeopleProfile>>>;
export type GetPeopleProfileQueryError = AxiosError<void | HTTPValidationError>;

export function useGetPeopleProfile<
  TData = Awaited<ReturnType<typeof getPeopleProfile>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfile>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPeopleProfile>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPeopleProfile<
  TData = Awaited<ReturnType<typeof getPeopleProfile>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfile>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPeopleProfile>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPeopleProfile<
  TData = Awaited<ReturnType<typeof getPeopleProfile>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfile>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get People Profile
 */

export function useGetPeopleProfile<
  TData = Awaited<ReturnType<typeof getPeopleProfile>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfile>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPeopleProfileQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Persist shareable contact and visibility preferences.
 * @summary Patch People Profile
 */
export const patchPeopleProfile = (
  userId: string,
  peopleProfilePatchRequest: PeopleProfilePatchRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponsePeopleProfile>> => {
  return axios.patch(`/users/${userId}/people-profile`, peopleProfilePatchRequest, options);
};

export const getPatchPeopleProfileMutationOptions = <
  TData = Awaited<ReturnType<typeof patchPeopleProfile>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: PeopleProfilePatchRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['patchPeopleProfile'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchPeopleProfile>>,
    { userId: string; data: PeopleProfilePatchRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return patchPeopleProfile(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; data: PeopleProfilePatchRequest },
    TContext
  >;
};

export type PatchPeopleProfileMutationResult = NonNullable<Awaited<ReturnType<typeof patchPeopleProfile>>>;
export type PatchPeopleProfileMutationBody = PeopleProfilePatchRequest;
export type PatchPeopleProfileMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Patch People Profile
 */
export const usePatchPeopleProfile = <
  TData = Awaited<ReturnType<typeof patchPeopleProfile>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: PeopleProfilePatchRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; data: PeopleProfilePatchRequest }, TContext> => {
  const mutationOptions = getPatchPeopleProfileMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Upload a JPEG profile photo to user-photos storage.
 * @summary Upload People Profile Photo
 */
export const uploadPeopleProfilePhoto = (
  userId: string,
  peopleProfilePhotoUploadRequest: PeopleProfilePhotoUploadRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponsePeopleProfile>> => {
  return axios.post(`/users/${userId}/people-profile/photo`, peopleProfilePhotoUploadRequest, options);
};

export const getUploadPeopleProfilePhotoMutationOptions = <
  TData = Awaited<ReturnType<typeof uploadPeopleProfilePhoto>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: PeopleProfilePhotoUploadRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['uploadPeopleProfilePhoto'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadPeopleProfilePhoto>>,
    { userId: string; data: PeopleProfilePhotoUploadRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return uploadPeopleProfilePhoto(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; data: PeopleProfilePhotoUploadRequest },
    TContext
  >;
};

export type UploadPeopleProfilePhotoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPeopleProfilePhoto>>>;
export type UploadPeopleProfilePhotoMutationBody = PeopleProfilePhotoUploadRequest;
export type UploadPeopleProfilePhotoMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Upload People Profile Photo
 */
export const useUploadPeopleProfilePhoto = <
  TData = Awaited<ReturnType<typeof uploadPeopleProfilePhoto>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: PeopleProfilePhotoUploadRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; data: PeopleProfilePhotoUploadRequest }, TContext> => {
  const mutationOptions = getUploadPeopleProfilePhotoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Owner-only SAS URL for profile photo display.
 * @summary Get People Profile Photo Url
 */
export const getPeopleProfilePhotoUrl = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponsePeopleProfilePhotoUrlResponse>> => {
  return axios.get(`/users/${userId}/people-profile/photo-url`, options);
};

export const getGetPeopleProfilePhotoUrlQueryKey = (userId: string) => {
  return [`/users/${userId}/people-profile/photo-url`] as const;
};

export const getGetPeopleProfilePhotoUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPeopleProfilePhotoUrlQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>> = ({ signal }) =>
    getPeopleProfilePhotoUrl(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPeopleProfilePhotoUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>>;
export type GetPeopleProfilePhotoUrlQueryError = AxiosError<void | HTTPValidationError>;

export function useGetPeopleProfilePhotoUrl<
  TData = Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPeopleProfilePhotoUrl<
  TData = Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPeopleProfilePhotoUrl<
  TData = Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get People Profile Photo Url
 */

export function useGetPeopleProfilePhotoUrl<
  TData = Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPeopleProfilePhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPeopleProfilePhotoUrlQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Owner-only SAS URL for the account profile photo (oral exam briefing, user menu).
 * @summary Get User Avatar
 */
export const getUserAvatar = (
  userId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponsePeopleProfilePhotoUrlResponse>> => {
  return axios.get(`/users/${userId}/avatar`, options);
};

export const getGetUserAvatarQueryKey = (userId: string) => {
  return [`/users/${userId}/avatar`] as const;
};

export const getGetUserAvatarQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAvatar>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAvatar>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserAvatarQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAvatar>>> = ({ signal }) =>
    getUserAvatar(userId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAvatar>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserAvatarQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAvatar>>>;
export type GetUserAvatarQueryError = AxiosError<void | HTTPValidationError>;

export function useGetUserAvatar<
  TData = Awaited<ReturnType<typeof getUserAvatar>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAvatar>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getUserAvatar>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAvatar<
  TData = Awaited<ReturnType<typeof getUserAvatar>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAvatar>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getUserAvatar>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAvatar<
  TData = Awaited<ReturnType<typeof getUserAvatar>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAvatar>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Avatar
 */

export function useGetUserAvatar<
  TData = Awaited<ReturnType<typeof getUserAvatar>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAvatar>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserAvatarQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a JPEG account avatar to user-photos storage.
 * @summary Upload User Avatar
 */
export const uploadUserAvatar = (
  userId: string,
  peopleProfilePhotoUploadRequest: PeopleProfilePhotoUploadRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponsePeopleProfilePhotoUrlResponse>> => {
  return axios.post(`/users/${userId}/avatar`, peopleProfilePhotoUploadRequest, options);
};

export const getUploadUserAvatarMutationOptions = <
  TData = Awaited<ReturnType<typeof uploadUserAvatar>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: PeopleProfilePhotoUploadRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['uploadUserAvatar'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadUserAvatar>>,
    { userId: string; data: PeopleProfilePhotoUploadRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return uploadUserAvatar(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { userId: string; data: PeopleProfilePhotoUploadRequest },
    TContext
  >;
};

export type UploadUserAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof uploadUserAvatar>>>;
export type UploadUserAvatarMutationBody = PeopleProfilePhotoUploadRequest;
export type UploadUserAvatarMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Upload User Avatar
 */
export const useUploadUserAvatar = <
  TData = Awaited<ReturnType<typeof uploadUserAvatar>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { userId: string; data: PeopleProfilePhotoUploadRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { userId: string; data: PeopleProfilePhotoUploadRequest }, TContext> => {
  const mutationOptions = getUploadUserAvatarMutationOptions(options);

  return useMutation(mutationOptions);
};
